/**
 * @Description 门店项
 */

import { FC, useMemo } from 'react';
import { Typography } from 'antd';
import styles from './index.module.less';
import cs from 'classnames';
import { StoreStatus } from '@/common/components/business/ExpandStore/ts-config';
import { isNotEmpty } from '@lhb/func';
import { dateFormatShow } from '@/common/utils/ways';

const DetailItem: FC<any> = ({ title, value, index, single }) => {
  return (
    <div key={index} className={single ? styles.honrizontalDetailItem : styles.detailItem}>
      <div className={styles.value}>{isNotEmpty(value) ? value : '-'}</div>
      <div className={styles.title}>{title}</div>
    </div>
  );
};

/** 门店状态颜色值 */
export const StoreStatusColor = {
  [StoreStatus.Signed]: '#2BC58B', // 已签约
  [StoreStatus.HouseDelivered]: '#2BC58B', // 已交房
  [StoreStatus.Opened]: '#006AFF', // 开业中
  [StoreStatus.Closed]: '#999999', // 已闭店
  [StoreStatus.Relocated]: '#999999', // 已迁址
  [StoreStatus.Terminated]: '#999999', // 已解约
};

export interface StoreItemProps {
  detail?: any; // 数据
  onClick?: Function; // 点击事件
  className?: any;
}

const StoreItem: FC<StoreItemProps> = ({ detail, onClick, className }) => {
  const detailInfos = useMemo(() => {
    const { status, typeName, contractStart, contractEnd, daysRemainingStr, openDate, closeDate } = detail;
    if ([StoreStatus.Signed, StoreStatus.HouseDelivered].includes(status)) {
      const start = contractStart ? dateFormatShow(contractStart) : '';
      const end = contractEnd ? dateFormatShow(contractEnd) : '';

      const arr: any = [];
      typeName && arr.push({ title: '门店类型', value: typeName });
      (start || end) && arr.push({ title: '合同起始时间', value: `${start || ''}-${end || ''}` });
      daysRemainingStr && arr.push({ title: '门店保护', value: daysRemainingStr });
      return arr;
    } else if (StoreStatus.Opened === status) {
      const arr: any = [];
      typeName && arr.push({ title: '门店类型', value: typeName });
      openDate && arr.push({ title: '开业时间', value: dateFormatShow(openDate) });
      daysRemainingStr && arr.push({ title: '门店保护', value: daysRemainingStr });
      return arr;
    } else if (StoreStatus.Closed === status) {
      const arr: any = [];
      typeName && arr.push({ title: '门店类型', value: typeName });
      openDate && arr.push({ title: '开业时间', value: dateFormatShow(openDate) });
      closeDate && arr.push({ title: '闭店时间', value: dateFormatShow(closeDate) });
      daysRemainingStr && arr.push({ title: '门店保护', value: daysRemainingStr });
      return arr;
    } else if ([StoreStatus.Relocated, StoreStatus.Terminated].includes(status)) {
      return typeName ? [
        { title: '门店类型', value: typeName, useSingle: true },
      ] : [];
    }
    return [];
  }, [detail]);

  return (
    <div className={cs(styles.storeItem, className)} onClick={() => onClick?.(detail)}>
      <div className={styles.basicInfos}>
        <div className={styles.leftWrapper}>
          <img src={detail?.logo || `${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/map/img_brand.png`}/>
        </div>
        <div className={styles.rightWrapper}>
          <div className={styles.titleRow}>
            <Typography.Text className={styles.title} ellipsis={{ tooltip: detail?.name }}>
              {detail?.name}
            </Typography.Text>
            <span className={styles.status} style={{ color: StoreStatusColor[detail?.status] || '' }}>
              {detail?.statusName}
            </span>
          </div>
          <div className='fs-12 c-666 mt-4'>
            <Typography.Text className={styles.address} ellipsis={{ tooltip: detail?.address }}>
              {detail?.address || '-'}
            </Typography.Text>
          </div>
        </div>
      </div>
      {
        detailInfos.length ? <div className={cs(styles.detailInfos, (detailInfos.length === 1) && styles.single)}>
          {
            detailInfos.map((info, index) => (<DetailItem
              title={info.title}
              value={info.value}
              key={index}
              single={info.useSingle && detailInfos.length === 1}
            />))
          }
          {/* 两项时继续体现三项类似的布局，位于左侧和中间 */}
          { detailInfos.length === 2 && <div style={{ minWidth: 86 }}></div> }
        </div> : <></>
      }
    </div>
  );
};

export default StoreItem;
